import React from 'react';
import { useTranslation } from 'react-i18next';
import { isRTL } from '../../i18n/config';
import SaasButton from '../saas/Button';
import SaasContainer from '../saas/Container';
import { LANDING_HERO_FLOATS } from '../../config/landingHeroConfig';
import LandingFloatingCard from './LandingFloatingCard';
import LandingHeroSearch from './LandingHeroSearch';

export default function LandingHeroEditorial() {
  const { t, i18n } = useTranslation();
  const ltr = !isRTL(i18n.language);

  return (
    <section className="landing-mesh-bg landing-grid-dots relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_70%_50%_at_50%_-10%,rgba(113,75,103,0.09)_0%,transparent_55%)]" aria-hidden />

      <SaasContainer className="relative z-10 pb-14 pt-8 md:pb-20 md:pt-12 lg:pb-24">
        <div className="relative mx-auto max-w-3xl lg:max-w-none">
          <div className="pointer-events-none absolute inset-x-0 top-0 hidden h-[340px] lg:block xl:h-[360px]" aria-hidden>
            {LANDING_HERO_FLOATS.map((card) => (
              <LandingFloatingCard key={card.id} {...card} />
            ))}
          </div>

          <div className="relative z-30 mx-auto flex max-w-2xl flex-col items-center text-center">
            <h1 className={`type-display text-4xl sm:text-5xl md:text-display ${ltr ? 'saas-display-track' : ''}`}>
              {t('hero.title')}
            </h1>
            <p className="type-lead mt-4 max-w-xl text-base sm:mt-5 sm:text-lg">{t('hero.description')}</p>

            <div className="mt-8 w-full sm:mt-10">
              <LandingHeroSearch />
            </div>

            <div className="mt-5 flex flex-wrap items-center justify-center gap-2.5 sm:gap-3">
              <SaasButton to="/join" variant="outline" className="!rounded-full !px-5 !py-2.5 text-[13px]">
                {t('hero.ctaBusiness')}
              </SaasButton>
              <SaasButton to="/login" variant="gradient" className="!rounded-full !px-5 !py-2.5 text-[13px]">
                {t('hero.ctaLogin')}
              </SaasButton>
            </div>
          </div>
        </div>
      </SaasContainer>
    </section>
  );
}
